import React from 'react';
import { Column } from '@ant-design/charts';

const ChartBar: React.FC = (props) => {
  const config = {
    data: props.allSeller,
    xField: 'seller_name',
    yField: 'COUNT',
    height: 300,
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
    }
  };
  return <Column {...config} />;
};

export default ChartBar;